exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#startBtn[data-v-c1e36678]{cursor:pointer;position:absolute;width:300px;margin-left:-150px;left:50%;z-index:3;top:32%}.cls-1[data-v-c1e36678]{fill:#e7545d}.cls-2[data-v-c1e36678]{font-size:42.36px;font-family:Roboto-Regular,Roboto}.cls-2[data-v-c1e36678],.cls-3[data-v-c1e36678]{fill:#fff}", ""]);

// exports
